export const iconFontAwesomeSecurityEye = (
	<i className="fa-solid fa-eye"></i>
);
